import { defineComponent, ref } from 'vue';
import { Button } from '@yellowcard/components-library-vue3';
import { useAuthStore } from '@/store/modules/auth';
import useTransactionsStore from '@/store/modules/transactions';
import { storeToRefs } from 'pinia';
import router from '@/router';
import { numberFormat } from '@/utils/helpers';
import { TransactTypes } from '@/types/transact';
export default defineComponent({
    name: 'TransactionLimit',
    components: {
        Button,
    },
    setup() {
        const goBack = () => router.push('/payment');
        const authStore = useAuthStore();
        const transactionStore = useTransactionsStore();
        const { user } = storeToRefs(authStore);
        const { txType, selectedCurrency, dailyLimitError, monthlyLimitError, lifetimeLimitError, } = storeToRefs(transactionStore);
        const limitValue = ref(0);
        if (txType.value === TransactTypes.TransactionType.BUY) {
            if (dailyLimitError.value) {
                limitValue.value = user.value?.tierLimit?.dailyBuyLimit;
            }
            if (monthlyLimitError.value) {
                limitValue.value = user.value?.tierLimit?.monthlyBuyLimit;
            }
            if (lifetimeLimitError.value) {
                limitValue.value = user.value?.tierLimit?.lifetimeBuyLimit;
            }
        }
        else {
            if (dailyLimitError.value) {
                limitValue.value = user.value?.tierLimit?.dailySellLimit;
            }
            if (monthlyLimitError.value) {
                limitValue.value = user.value?.tierLimit?.monthlySellLimit;
            }
            if (lifetimeLimitError.value) {
                limitValue.value = user.value?.tierLimit?.lifetimeBuyLimit;
            }
        }
        const onKeyPress = () => console.log('');
        return {
            goBack,
            onKeyPress,
            numberFormat,
            limitValue,
            selectedCurrency,
        };
    },
});
